// API base URL - defaults to relative path for same-origin, can be overridden via env var
export const API_BASE_URL = import.meta.env.VITE_API_URL || ""

// Prelude API URL for authentication
export const PRELUDE_API_URL = import.meta.env.VITE_PRELUDE_API_HOST || "https://prelude-ai.net"

// Set at build time from USE_STAGING (see vite.config.ts). The staging API only accepts
// redirect_uris on its own domains, so local logins can't go through this dev server.
export const USE_STAGING = import.meta.env.VITE_USE_STAGING === "true"

// Set at build time when PRELUDE_SESSION is present in the environment (see vite.config.ts).
// The backend injects that session in development, so no interactive login is needed.
export const HAS_PRELUDE_SESSION = import.meta.env.VITE_HAS_PRELUDE_SESSION === "true"
